module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/image--business-circle-3-5d08d898.png";